export default {
    manufacturer_create_success_message: "Se ha creado el fabricante",
    manufacturer_create_title: "Crear fabricante",
    manufacturer_edit_success_message: "El fabricante ha sido editado",
    manufacturer_edit_title: "Editar Fabricante",
    manufacturer_name: "Nombre",
    manufacturer_status: "Estado",
    manufacturer_active: "Activo",
    manufacturer_inactive: "Inactivo",
}